/**
 * React Shim
 * 
 * This file ensures that all components use the same instance of React.
 * It helps prevent the "Cannot read properties of undefined (reading 'forwardRef')" error
 * that can occur when multiple instances of React are loaded.
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';

// Export React and ReactDOM to ensure consistent usage
export { React, ReactDOM, ReactDOMClient };

// Export common React hooks and utilities to ensure they all use the same React instance
export const {
  useState,
  useEffect,
  useContext,
  useReducer,
  useCallback,
  useMemo,
  useRef,
  useLayoutEffect,
  useImperativeHandle,
  useDebugValue,
  useDeferredValue,
  useTransition,
  startTransition,
  useId,
  createContext,
  forwardRef,
  memo,
  Fragment,
  Suspense,
  lazy,
  createElement,
  cloneElement,
  isValidElement,
  Children
} = React;

// Export createRoot from ReactDOM client
export const { createRoot } = ReactDOMClient;

// Default export for convenience
export default React;
